import {handleError} from '../handleError'
import axios from 'axios'
const state = {
}
const getters = {}

const mutations = {
}

const actions = {
  // 获取计费分类列表
  async getRuleGroup ({dispatch}, {pagination, sortStack, search, filter}) {
    let {items, amount} = await dispatch('getDataList', {
      url: '/chargingApi/smaco/charging/rule/classi/list',
      pagination,
      sortStack,
      search,
      filter: filter || {}
    }, {root: true})
    return {
      items,
      amount
    }
  },
  // 获取计费规则模板列表
  async getRuleTemplateList ({dispatch}, {pagination, sortStack, search, filter}) {
    let {items, amount} = await dispatch('getDataList', {
      url: '/chargingApi/smaco/charging/rule/tmplt/list',
      pagination,
      sortStack,
      search,
      filter: filter || {}
    }, {root: true})
    return {
      items,
      amount
    }
  },
  // 获取周期计费规则列表
  async getPeriodConfigList ({dispatch}, {pagination, sortStack, search, filter}) {
    let {items, amount} = await dispatch('getDataList', {
      url: '/chargingApi/smaco/charging/rule/period/list',
      pagination,
      sortStack,
      search,
      filter: filter || {}
    }, {root: true})
    return {
      items,
      amount
    }
  },
  // 获取计费规则列表
  async getRuleConfigList ({dispatch}, {pagination, sortStack, search, filter}) {
    let {items, amount} = await dispatch('getDataList', {
      url: '/chargingApi/smaco/charging/rule/config/list',
      pagination,
      sortStack,
      search,
      filter: filter || {}
    }, {root: true})
    return {
      items,
      amount
    }
  },
  // 获取计费历史列表
  async getCalculateResultList ({dispatch}, {pagination, sortStack, search, filter}) {
    let {items, amount} = await dispatch('getDataList', {
      url: '/chargingApi/smaco/charging/result',
      pagination,
      sortStack,
      search,
      filter: filter || {}
    }, {root: true})
    return {
      items,
      amount
    }
  },
  // 选择单位列表
  async getOrgs ({dispatch}, {name, id}) {
    let url = '/shiroApi/group/list?page=0&size=10&type=reg&name=' + (name) + '&id=' + id
    try {
      let res = null
      res = await axios.post(url, {})
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  // 添加规则分类
  async addRuleGroup ({dispatch}, params) {
    let url = '/chargingApi/smaco/charging/rule/classi/'
    try {
      let res = await axios.post(url, params)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  // 删除规则分类
  async deleteRuleGroup ({dispatch}, id) {
    let url = '/chargingApi/smaco/charging/rule/classi/' + id
    try {
      let res = await axios.delete(url)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  // 修改规则分类
  async updateRuleGroup ({dispatch}, params) {
    let url = '/chargingApi/smaco/charging/rule/classi'
    try {
      let res = await axios.put(url, params)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  // 添加计费规则模板
  async addRuleTemplate ({dispatch}, params) {
    let url = '/chargingApi/smaco/charging/rule/tmplt/'
    try {
      let res = await axios.post(url, params)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  // 删除计费规则模板
  async deleteRuleTemplate ({dispatch}, id) {
    let url = '/chargingApi/smaco/charging/rule/tmplt/' + id
    try {
      let res = await axios.delete(url)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  // 修改计费规则模板
  async updateRuleTemplate ({dispatch}, params) {
    let url = '/chargingApi/smaco/charging/rule/tmplt/'
    try {
      let res = await axios.put(url, params)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  // 添加简单计费规则
  async addSimpleRule ({dispatch}, params) {
    let url = '/chargingApi/smaco/charging/rule/config/'
    try {
      let res = await axios.post(url, params)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  // 删除简单计费规则
  async deleteSimpleRule ({dispatch}, id) {
    let url = '/chargingApi/smaco/charging/rule/config/' + id
    try {
      let res = await axios.delete(url)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  // 修改简单计费规则
  async updateSimpleRule ({dispatch}, params) {
    let url = '/chargingApi/smaco/charging/rule/config/'
    try {
      let res = await axios.put(url, params)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  // 添加周期计费规则
  async addPeriodRule ({dispatch}, params) {
    let url = '/chargingApi/smaco/charging/rule/period/'
    try {
      let res = await axios.post(url, params)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  // 删除周期计费规则
  async deletePeriodRule ({dispatch}, id) {
    let url = '/chargingApi/smaco/charging/rule/period/' + id
    try {
      let res = await axios.delete(url)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  // 更新周期计费规则
  async updatePeriodRule ({dispatch}, params) {
    let url = '/chargingApi/smaco/charging/rule/period/'
    try {
      let res = await axios.put(url, params)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  // 计费虚拟测试
  async chargingTest ({dispatch}, params) {
    let url = '/chargingApi/smaco/charging/exec/test'
    try {
      let res = await axios.post(url, params)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
